import { generateClasses } from '@formkit/themes'
import Globals from './globals'
import Families from './families'
import Inputs from './inputs'

export default generateClasses({
  global: Globals,
  ...Families,
  ...Inputs,
})
